import React, { useState, useEffect } from 'react'
import { ActiveSellers } from '../components'
import { getCompany } from '../utils/functions'
import useDebounce from '../utils/useDebounce'

export default function SellerActiveListPage() {
    const [allSellers, setAllSellers] = useState([])
    const [sellers, setSellers] = useState([])
    const [pageSkip, setPageSkip] = useState(0)
    const [limit, setLimit] = useState(100)
    const [pageAll, setPageAll] = useState(0)
    const [check, setCheck] = useState(false)

    const [userId, setUserId] = useState('')
    const [plan_type, setPlanType] = useState('')
    const [isFeatured, setIsFeatured] = useState(false)
    const [isVerified, setIsVerified] = useState(false)
    const [sellerData, setSellerData] = useState()

    // Search system
    const [search, setSearch] = useState({
        value: '',
        searchBy: 'name',
        isSearchAble: false,
    })
    const debouncedSearchValue = useDebounce(search.value, 700)

    const [selectedDates, setSelectedDates] = useState({ startDate: '', endDate: '' })
    const handleDateChange = (dates) => {
        setSelectedDates(dates)
    }

    const [istrue, setTrue] = useState(false)

    // Fetch filtered sellers
    useEffect(() => {
        async function fetchSellers() {
            const params = {
                seller_full_id: '',
                name: '',
                phone: '',
                skip: pageSkip,
                limit: 10,
                start_date: selectedDates.startDate,
                end_date: selectedDates.endDate,
                plan_type,
                is_verify: isVerified ? 'true' : 'false',
                is_feature: isFeatured ? 'true' : 'false',
            }

            if (search.isSearchAble && debouncedSearchValue) {
                params[search.searchBy] = debouncedSearchValue
            }

            const [meta, items] = await getCompany(params)

            if (meta) {
                setSellers(items)
                setPageAll(meta.results)
            }

            setCheck(false)
        }

        fetchSellers()
    }, [
        debouncedSearchValue,
        pageSkip,
        selectedDates.endDate,
        plan_type,
        isVerified,
        isFeatured,
        check,
        search.isSearchAble,
    ])

    // Fetch all sellers (for CSV / dropdown)
    useEffect(() => {
        async function fetchAll() {
            const [meta, items] = await getCompany({
                name: '',
                skip: 0,
                limit: limit,
            })

            if (meta) {
                setAllSellers(items)
                setLimit(meta.results)
            }
        }

        fetchAll()
    }, [limit, check])

    // Reset page if search changes
    useEffect(() => {
        if (search.isSearchAble) setPageSkip(0)
    }, [search])

    return (
        <ActiveSellers
            sellers={sellers}
            pageAll={pageAll}
            pageSkip={pageSkip}
            setPageSkip={setPageSkip}
            allSellers={allSellers}
            handleDateChange={handleDateChange}
            istrue={istrue}
            setTrue={setTrue}
            userId={userId}
            setUserId={setUserId}
            sellerData={sellerData}
            setSellerData={setSellerData}
            plan_type={plan_type}
            setPlanType={setPlanType}
            check={check}
            isVerified={isVerified}
            setIsVerified={setIsVerified}
            isFeatured={isFeatured}
            setIsFeatured={setIsFeatured}
            setCheck={setCheck}
            search={search}
            setSearch={setSearch}
        />
    )
}
